import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import { Cell, Row, downloadSheets, generateSheet } from '../../../utils';
import XLSX, { Range } from 'xlsx-js-style';
import {
  Dropdown,
  DropdownButton,
  Row as BSRow,
  Table,
} from 'react-bootstrap';
import { AuthedLayout } from '../../../components';
import { ClassWHAvgStatistic, UserInfo } from '../../../model';
import { useSemGrade } from '../../../hook';
import apis from '../../../apis';
import { toast } from 'react-toastify';

const HDID = {
  // Total: -9,
  UnderWeight: -1,
  Healty: 0,
  OverWeight: 1,
  Obesity: 2,
};

const borderStyle = { color: { rgb: '000000' }, style: 'thin' } as const;
const fullBorderStyle = {
  top: borderStyle,
  bottom: borderStyle,
  left: borderStyle,
  right: borderStyle,
} as const;
const cellAlignStyle = {
  horizontal: 'center',
  vertical: 'center',
} as const;

const mapState = (state: ApplicationState) => ({ ...state.auth });
const mapDispatches = ErrorDispatches;

const connector = connect(mapState, mapDispatches);

type Props = ConnectedProps<typeof connector>;

const whClassAvg: FunctionComponent<Props> = ({ catchErrorForModal }) => {
  const { yearSem, element } = useSemGrade();
  const [datas, setDatas] = useState<ClassWHAvgStatistic[]>([]);
  const [userinfo, setUser] = useState<UserInfo>();
  useEffect(() => {
    if (yearSem) {
      apis.getUserInfo()
        .then((u) => {
          setUser(u);
        })
        .catch(catchErrorForModal);

      toast
        .promise(
          apis
            .getWHClassAvg(yearSem.year, yearSem.sem)
            .then(r => {
              setDatas(r);
            }),
          {
            pending: '資料載入中......',
            success: '資料載入成功！',
            error: '資料載入失敗！請查看錯誤資訊。',
          }
        )
    }
  }, [yearSem?.year, yearSem?.sem]);

  const gradeBase = datas.reduce((grades, d) => {
    return { ...grades, [d.grade]: [...(grades[d.grade] || []), d] };
  }, {} as Record<number, ClassWHAvgStatistic[]>);

  const contentRows: Row[] = Object.values(gradeBase).flatMap(
    (gs, idx, allArray) => {
      const rows = gs.flatMap((g, idx) => {
        return whavgToRows(
          g.grade,
          g.maleHavg,
          g.maleWavg,
          g.maleBMIavg,
          g.femaleHavg,
          g.femaleWavg,
          g.femaleBMIavg,
          g.totalHavg,
          g.totalWavg,
          g.totalBMIavg
        );
      });
      return rows;
    }
  );
  const content: Row[] = [
    {
      cells: [
        {
          value: '年級',
          merge: { column: 1, row: 2 },
          style: { border: fullBorderStyle },
        },
        {
          value: '男',
          merge: { column: 3 },
          style: { border: fullBorderStyle },
        },
        {
          value: '女',
          merge: { column: 3 },
          style: { border: fullBorderStyle },
        },
        {
          value: '男女平均',
          merge: { column: 3 },
          style: { border: fullBorderStyle },
        },
      ],
    },
    {
      cells: [
        {
          merge: { column: 1, row: 1 },
          style: { border: fullBorderStyle },
        },
        {
          value: '身高A',
          merge: { column: 1 },
          style: { border: fullBorderStyle },
        },
        {
          value: '體重B',
          merge: { column: 1 },
          style: { border: fullBorderStyle },
        },
        {
          value: 'BMI（C）',
          merge: { column: 1 },
          style: { border: fullBorderStyle },
        },
        {
          value: '身高A',
          merge: { column: 1 },
          style: { border: fullBorderStyle },
        },
        {
          value: '體重B',
          merge: { column: 1 },
          style: { border: fullBorderStyle },
        },
        {
          value: 'BMI（C）',
          merge: { column: 1 },
          style: { border: fullBorderStyle },
        },
        {
          value: '身高A',
          merge: { column: 1 },
          style: { border: fullBorderStyle },
        },
        {
          value: '體重B',
          merge: { column: 1 },
          style: { border: fullBorderStyle },
        },
        {
          value: 'BMI（C）',
          merge: { column: 1 },
          style: { border: fullBorderStyle },
        },
      ],
    },
    ...contentRows,
  ];

  const workSheet = generateSheet(content, { alignment: cellAlignStyle });

  const handleExcelDownload = () => {
    const workSheet = generateSheet(
      [
        {
          cells: [
            {
              value: `${yearSem?.year}學年第${yearSem?.sem}學期_生長發育統計報表`,
              style: { alignment: { horizontal: 'left' } },
            },
          ],
        },
        {
          cells: [
            {
              value: `一、A：身高`,
              style: { alignment: { horizontal: 'left' } },
              merge: { column: 3 },
            },
            {
              value: ` B：體重`,
              style: { alignment: { horizontal: 'left' } },
              merge: { column: 3 },
            },
            {
              value: `C：BMI（ B / A(公尺)² ）`,
              style: { alignment: { horizontal: 'left' } },
              merge: { column: 3 },
            },
          ],
        },
        ...content,
        {
          cells: [
            {
              value:
                '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
              style: { alignment: { horizontal: 'left' } },
            },
          ],
        },
      ],
      {
        alignment: cellAlignStyle,
      }
    );

    downloadSheets(
      `${yearSem?.year}學年第${yearSem?.sem}學期_生長發育統計報表`,
      userinfo?.exportFileType,
      {
        sheet: workSheet,
        name: 'st',
      }
    );
  };

  const handlePrint = () => {
    const printWindow = window.open(
      '',
      '_blank',
      'width=1200,height=800'
    );

    if (!printWindow) {
      alert('瀏覽器阻擋了列印視窗，請允許彈出式視窗。');
      return;
    }

    const escapeHtml = (value: unknown): string => {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    };

    const title =
      `${yearSem?.year}學年第${yearSem?.sem}學期_生長發育統計報表`;

    const tableRows = content
      .map((row) => {
        const cells = row.cells
          .map((cell) => {
            if (cell.value === undefined) {
              return '';
            }

            const colSpan = cell.merge?.column
              ? ` colspan="${cell.merge.column}"`
              : '';

            const rowSpan = cell.merge?.row
              ? ` rowspan="${cell.merge.row}"`
              : '';

            return `
            <td${colSpan}${rowSpan}>
              ${escapeHtml(cell.value)}
            </td>
          `;
          })
          .join('');

        return `<tr>${cells}</tr>`;
      })
      .join('');

    printWindow.document.open();

    printWindow.document.write(`
    <!DOCTYPE html>
    <html lang="zh-Hant">
      <head>
        <meta charset="UTF-8" />

        <title>${escapeHtml(title)}</title>

        <style>
          * {
            box-sizing: border-box;
          }

          html,
          body {
            margin: 0;
            padding: 0;

            font-family:
              "Microsoft JhengHei",
              "Noto Sans TC",
              Arial,
              sans-serif;

            color: #000;
          }

          .print-page {
            min-height: 190mm;

            display: flex;
            flex-direction: column;
          }

          h1 {
            margin: 0 0 10px;
            text-align: center;
            font-size: 20px;
          }

          .description {
            margin-bottom: 12px;
            font-size: 13px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
          }

          td {
            border: 1px solid #000;
            padding: 6px 4px;
            text-align: center;
            vertical-align: middle;
            font-size: 12px;
            word-break: break-word;
          }

          .footer {
    margin-top: auto;
    padding-top: 16px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    width: 100%;
}

          @page {
            size: A4 landscape;
            margin: 10mm;
          }

          @media print {
            body {
              padding: 0;
            }

            tr {
              page-break-inside: avoid;
              break-inside: avoid;
            }
          }
        </style>
      </head>

      <body>
        <div class="print-page">
          <h1>${escapeHtml(title)}</h1>

          <div class="description">
            一、A:身高 B:體重 C:BMI( B / A(公尺)² )
          </div>

          <table>
            <tbody>
              ${tableRows}
            </tbody>
          </table>

          <div class="footer">
  <span>承辦人:</span>
  <span>組長:</span>
  <span>主任:</span>
  <span>校長:</span>
</div>
        </div>

        <script>
          window.onload = function () {
            window.focus();

            setTimeout(function () {
              window.print();
            }, 300);
          };

          window.onafterprint = function () {
            window.close();
          };
        </script>
      </body>
    </html>
  `);

    printWindow.document.close();
  };

  return (
    <AuthedLayout>
      <BSRow className="justify-content-between">
        <span className="mr-3">{element}</span>
        <DropdownButton
          id="wh-class-avg-export"
          title="匯出"
          variant="success"
          disabled={!datas.length}
        >
          <Dropdown.Item onClick={handleExcelDownload}>
            Excel 下載
          </Dropdown.Item>

          <Dropdown.Item onClick={handlePrint}>
            列印
          </Dropdown.Item>
        </DropdownButton>
      </BSRow>
      <hr />
      <BSRow>
        <Table
          striped
          bordered
          className="text-center"
          style={{ tableLayout: 'fixed' }}
        >
          <colgroup>
            <col style={{ width: '5%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '6%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
          </colgroup>
          <tbody>
            {content.map((r, i) => {
              const cells = r.cells.map((c, j) =>
                c.value != undefined ? (
                  <td
                    colSpan={c.merge?.column}
                    rowSpan={c.merge?.row}
                    key={`${i}-${j}`}
                  >
                    {c.value}
                  </td>
                ) : (
                  <Fragment key={`${i}-${j}`}></Fragment>
                )
              );
              return <tr key={i}>{cells}</tr>;
            })}
          </tbody>
        </Table>
      </BSRow>
    </AuthedLayout>
  );
};

function whavgToRows(
  grade: number,
  mHavg: number,
  mWavg: number,
  mBMIavg: number,
  fHavg: number,
  fWavg: number,
  fBMIavg: number,
  totalHavg: number,
  totalWavg: number,
  totalBMIavg: number,
): Row[] {
  return [
    {
      cells: [
        {
          value: grade,
          style: { border: { left: borderStyle } },
        },
        {
          value: formatZeroEmpty(mHavg, 2),
          style: { border: { right: borderStyle } },
        },
        {
          value: formatZeroEmpty(mWavg, 2),
          style: { border: { right: borderStyle } },
        },
        {
          value: formatZeroEmpty(mBMIavg, 1),
          style: { border: { right: borderStyle } },
        },
        {
          value: formatZeroEmpty(fHavg, 2),
          style: { border: { right: borderStyle } },
        },
        {
          value: formatZeroEmpty(fWavg, 2),
          style: { border: { right: borderStyle } },
        },
        {
          value: formatZeroEmpty(fBMIavg, 1),
          style: { border: { right: borderStyle } },
        },
        {
          value: avgIgnoreZero(mHavg, fHavg),
          style: { border: { right: borderStyle } },
        },
        {
          value: avgIgnoreZero(mWavg, fWavg),
          style: { border: { right: borderStyle } },
        },
        {
          value: avgIgnoreZero(
            parseFloat(mBMIavg.toFixed(1)),
            parseFloat(fBMIavg.toFixed(1))
          ),
          style: { border: { right: borderStyle } },
        },
      ],
    },
  ];
}

function avgIgnoreZero(a: number, b: number) {
  const values = [a, b].filter(v => v && v !== 0);
  if (values.length === 0) return "";
  return (values.reduce((sum, v) => sum + v, 0) / values.length).toFixed(2);
}

function formatZeroEmpty(v: number, digit = 2) {
  if (!v || v === 0) return "";
  return v.toFixed(digit);
}
export const WHClassAvg = connector(whClassAvg);
